import Vue from 'vue'
import Router from 'vue-router'

import a from '../components/a.header.vue'
import b from '../components/b.wechat.vue'
import c from '../components/c.game.vue'
// import e from '../components/b.game.vue'
// import d from '../components/d.down.vue'
import footer from '../components/footer.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name:'main',
            components: {
                a: a,
                b: b,
                c: c,
                // e: e,
                footer: footer
            }
        },
        {
            path: '*',
            redirect: { name: 'main' }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js